import { render, staticRenderFns } from "./MarketProductTableVariantPrice.vue?vue&type=template&id=1778fab5&"
import script from "./MarketProductTableVariantPrice.vue?vue&type=script&lang=js&"
export * from "./MarketProductTableVariantPrice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports